import { Component, OnInit } from '@angular/core';
import { ModalController, LoadingController, AlertController, NavParams } from '@ionic/angular';
import { RegisterService } from '../../services/register.service';
import { PricingTierService } from 'src/app/services/pricing-tier.service';
import { SupportedCurrencyService } from 'src/app/services/supported-currency.service';
import * as moment from 'moment';
import { StorageService } from '../../services/storage.service';
import { ConnectedAccountService } from '../../services/connected-account.service';
import { DateTimePickerPage } from './../../modals/date-time-picker/date-time-picker.page';
import { APIService } from '../../services/api.service';
import { AuthService } from '../../services/auth.service';
import { UserService } from '../../services/user.service';
import { Router } from '@angular/router';
import { ObserverService } from '../../services/observer.service';
import { OrganisationService } from '../../services/organisation.service';
import { OrganisationPickerPage } from '../../modals/organisation-picker/organisation-picker.page';
import { AffiliatePickerPage } from '../../modals/affiliate-picker/affiliate-picker.page';
import { Capacitor } from '@capacitor/core';

@Component({
    selector: 'app-order-filter',
    templateUrl: './order-filter.page.html',
    styleUrls: ['./order-filter.page.scss'],
})

export class OrderFilterPage implements OnInit {

    spinner = null;
    loading_spinner = null;
    loading = false;
    online = true;
    filter_params = {};
    pricing_tiers = [];
    supported_currencies = null;
    registers = [];
    register_id = null;
    register = null;
    locations = [];
    organisation = null;
    organisation_title = null;
    hide_organisation_selector = false
    affiliate = null;
    affiliate_name = null;
    moment = moment;
    formatted_from_date = null;
    formatted_to_date = null;
    date_modal_css_class = '';

    timeframe_options: any = { header: 'Timeframe' };
    is_awaiting_fulfillment_options: any = { header: 'Awaiting fulfillment' };
    is_awaiting_payment_options: any = { header: 'Awaiting payment' };
    status_options: any = { header: 'Status' };
    payment_status_options: any = { header: 'Payment status' };
    fulfillment_status_options: any = { header: 'Fulfillment status' };
    return_status_options: any = { header: 'Return status' };
    refund_status_options: any = { header: 'Refund status' };
    awaiting_payment_method_options: any = { header: 'Awaiting payment method' };
    channel_options: any = { header: 'Channel' };
    register_options: any = { header: 'Register' };
    pricing_tier_options: any = { header: 'Pricing tier' };
    currency_options: any = { header: 'Currency' };
    location_options: any = { header: 'Location' };
    archived_options: any = { header: 'Archived' };

    // modal flags
    date_picker_modal_open = false;
    organisation_picker_modal_open = false;
    affiliate_picker_modal_open = false;

    constructor(
        public modalController: ModalController,
        public alertController: AlertController,
        public navParams: NavParams,
        public loadingController: LoadingController,
        private registerService: RegisterService,
        private pricingTierService: PricingTierService,
        private supportedCurrencyService: SupportedCurrencyService,
        private storageService: StorageService,
        private connectedAccountService: ConnectedAccountService,
        private router: Router,
        private apiService: APIService,
        private authService: AuthService,
        private observerService: ObserverService,
        private organisationService: OrganisationService,
        private userService: UserService
    ) { }

    ngOnInit() {

        if(Capacitor.isNativePlatform()) {
            this.date_modal_css_class = 'backdrop';
        }

        this.loadData().then(async () => {

            // NOTE: order list has been called from organisation view
            if(this.navParams.get('hide_organisation_selector')) {
                this.hide_organisation_selector = this.navParams.get('hide_organisation_selector');
            }

            if(this.navParams.get('timeframe')) {
                this.filter_params['timeframe'] = this.navParams.get('timeframe');
            }
            else {
                if(this.navParams.get('from_date') || this.navParams.get('to_date')) {
                    this.storageService.get("connected_account_id").then((connected_account_id) => {
                        if(connected_account_id) {
                            this.connectedAccountService.getConnectedAccount(connected_account_id).then((connected_account: any) => {
                                if(connected_account['user_id']) {
                                    this.userService.getUser(connected_account['user_id']).then((user: any) => {
                                        if(this.navParams.get("from_date")) {
                                            this.filter_params['from_date'] = this.moment.utc(this.navParams.get("from_date")).tz(user.timezone.code).toISOString(true);
                                            this.formatted_from_date = this.moment(this.filter_params['from_date']).format("D MMM YYYY, HH:mm");
                                        }
                                        if(this.navParams.get("to_date")) {
                                            this.filter_params['to_date'] = this.moment.utc(this.navParams.get("to_date")).tz(user.timezone.code).toISOString(true);
                                            this.formatted_to_date = this.moment(this.filter_params['to_date']).format("D MMM YYYY, HH:mm");
                                        }
                                    });
                                }
                            });
                        }
                    });
                }
            }

            if(this.navParams.get('is_awaiting_fulfillment') != undefined) {
                this.filter_params['is_awaiting_fulfillment'] = this.navParams.get('is_awaiting_fulfillment');
            }

            if(this.navParams.get('is_awaiting_payment') != undefined) {
                this.filter_params['is_awaiting_payment'] = this.navParams.get('is_awaiting_payment');
            }

            if(this.navParams.get('status')) {
                this.filter_params['status'] = this.navParams.get('status');
            }

            if(this.navParams.get('payment_status')) {
                this.filter_params['payment_status'] = this.navParams.get('payment_status');
            }

            if(this.navParams.get('fulfillment_status')) {
                this.filter_params['fulfillment_status'] = this.navParams.get('fulfillment_status');
            }

            if(this.navParams.get('return_status')) {
                this.filter_params['return_status'] = this.navParams.get('return_status');
            }

            if(this.navParams.get('refund_status')) {
                this.filter_params['refund_status'] = this.navParams.get('refund_status');
            }

            if(this.navParams.get('awaiting_payment_method')) {
                this.filter_params['awaiting_payment_method'] = this.navParams.get('awaiting_payment_method');
            }

            if(this.navParams.get('channel')) {
                this.filter_params['channel'] = this.navParams.get('channel');
            }

            if(this.navParams.get('register_id')) {
                this.filter_params['register_id'] = this.navParams.get('register_id');
            }

            if(this.navParams.get('pricing_tier_id')) {
                this.filter_params['pricing_tier_id'] = this.navParams.get('pricing_tier_id');
            }

            if(this.navParams.get('currency_id')) {
                this.filter_params['currency_id'] = this.navParams.get('currency_id');
            }

            if(this.navParams.get('location_id')) {
                this.filter_params['location_id'] = this.navParams.get('location_id');
            }

            if(this.navParams.get('archived') != undefined) {
                this.filter_params['archived'] = this.navParams.get('archived');
            }

            if(this.navParams.get('organisation_id')) {
                this.filter_params['organisation_id'] = this.navParams.get('organisation_id');
                this.organisationService.getOrganisation(this.filter_params['organisation_id'],{}).then((organisation) => {
                    if(organisation) {
                        this.organisation_title = organisation["title"];
                    }
                })
                .catch(() => { });
            }

            if(this.navParams.get('affiliate_id')) {
                this.filter_params['affiliate_id'] = this.navParams.get('affiliate_id');
                this.loadAffiliate().then(() => {
                    this.affiliate_name = this.affiliate.name;
                })
                .catch(() => { });
            }

        })
        .catch(() => { });

        this.observerService.subscribe('network_status_changed|order_filter_modal', (network_status) => {
            if(network_status) {
                this.online = network_status.connected;
                if(this.online) {
                    this.loadData().then(() => { }).catch(() => { });
                }
                else {
                    this.presentAlert("Problem", "Offline", "You must be online to filter orders, please check your network connection and try again.");
                }
            }
        });

    }

    loadData() {
        return new Promise<void>((resolve, reject) => {
            this.presentLoadingSpinner("Loading registers").then(() => {
                this.loadRegisters().then(() => {
                    this.loading_spinner.message = "Loading pricing tiers";
                    this.loadPricingTiers().then(() => {
                        this.loading_spinner.message = "Loading currencies";
                        this.loadSupportedCurrencies().then(() => {
                            this.storageService.get("register_id").then((register_id) => {
                                if(register_id) {
                                    this.register_id = register_id;
                                    this.registerService.getRegister(this.register_id).then((register) => {
                                        if(register) {
                                            this.register = register;
                                            for(let i = 0; i < this.supported_currencies.length; i++) {
                                                // NOTE: default currency
                                                if(this.supported_currencies[i].id == this.register['location'].default_currency.id) {
                                                    let register_location_default_currency = this.supported_currencies.splice(i, 1)[0];
                                                    this.supported_currencies.unshift(register_location_default_currency);
                                                    break;
                                                }
                                            }
                                        }
                                    })
                                    .catch(() => { });
                                }
                            })
                            .catch(() => { });
                            this.loading_spinner.message = "Loading locations";
                            this.loadLocations().then(() => {
                                this.loading_spinner.dismiss();
                                resolve();
                            })
                            .catch(() => {
                                this.loading_spinner.dismiss();
                                reject();
                            });
                        })
                        .catch(() => {
                            this.loading_spinner.dismiss();
                            reject();
                        });
                    })
                    .catch(() => {
                        this.loading_spinner.dismiss();
                        reject();
                    });
                })
                .catch(() => {
                    this.loading_spinner.dismiss();
                    reject();
                });
            });
        });
    }


    loadRegisters() {
        return new Promise<void>((resolve, reject) => {
            this.registers = [];
            this.registerService.getRegisters().then((registers:[]) => {
                if(registers) {
                    this.registers = registers;
                    let register_found = false
                    for(let i = 0; i < this.registers.length; i++) {
                        if(this.registers[i].id == this.filter_params['register_id']) {
                            register_found = true;
                            break
                        }
                    }
                    if(!register_found) {
                        delete this.filter_params['register_id'];
                    }
                }
                resolve();
            })
            .catch(() => {
                reject();
            });
        });
    }

    loadPricingTiers() {
        return new Promise<void>((resolve, reject) => {
            this.pricing_tiers = [];
            this.pricingTierService.getPricingTiers().then((pricing_tiers: any) => {
                if(pricing_tiers) {
                    pricing_tiers.sort((a, b) => {
                        if(a['order'] < b['order']) { return -1; }
                        if(a['order'] > b['order']) { return 1; }
                        return 0;
                    });
                    this.pricing_tiers = pricing_tiers;
                    let pricing_tier_found = false
                    for(let i = 0; i < this.pricing_tiers.length; i++) {
                        if(this.pricing_tiers[i].id == this.filter_params['pricing_tier_id']) {
                            pricing_tier_found = true;
                            break
                        }
                    }
                    if(!pricing_tier_found) {
                        delete this.filter_params['pricing_tier_id'];
                    }
                }
                resolve();
            })
            .catch(() => {
                reject();
            });
        });
    }

    loadSupportedCurrencies() {
        return new Promise<void>((resolve, reject) => {
            this.supportedCurrencyService.getSupportedCurrencies().then((supported_currencies: any) => {
                if(supported_currencies) {
                    supported_currencies.sort((a, b) => {
                        if (a['title'].toLowerCase() < b['title'].toLowerCase()) { return -1; }
                        if (a['title'].toLowerCase() > b['title'].toLowerCase()) { return 1; }
                        return 0;
                    });
                    this.supported_currencies = supported_currencies;
                    let currency_found = false
                    for(let i = 0; i < this.supported_currencies.length; i++) {
                        if(this.supported_currencies[i].id == this.filter_params['currency_id']) {
                            currency_found = true;
                            break
                        }
                    }
                    if(!currency_found) {
                        delete this.filter_params['currency_id'];
                    }
                }
                resolve();
            })
            .catch(() => {
                reject();
            });
        })
    }

    loadLocations() {
        return new Promise<void>((resolve, reject) => {
            this.authService.isLoggedIn().then(() => {
                this.apiService.getLocations().then((locations: []) => {
                    if(locations) {
                        this.locations = locations;
                        let location_found = false
                        for(let i = 0; i < this.locations.length; i++) {
                            if(this.locations[i].id == this.filter_params['location_id']) {
                                location_found = true;
                                break
                            }
                        }
                        if(!location_found) {
                            delete this.filter_params['location_id'];
                        }
                    }
                    resolve();
                })
                .catch((error) => {
                    if(error) {
                        if(error.status) {
                            if(error.status == 400) {
                                this.presentAlert("Problem", "Unknown error", "Unfortunately something went wrong when trying to retrieve a list of locations.");
                            }
                            else if(error.status == 403) {
                                this.presentAlert("Problem", "Insufficient permissions", "You don't have permission to view location.");
                            }
                            else if(error.status == 404 || error.status == 0) {
                                this.presentAlert("Problem", "Unavailable", "Unfortunately we're unable to retrieve a list of locations at this time.");
                            }
                        }
                    }
                    reject();
                });
            })
            .catch(() => {
                this.router.navigate(['switch-account'], { replaceUrl: true }).then(() => {
                    window.location.reload();
                });
            });
        });
    }

    loadAffiliate() {
        return new Promise<void>((resolve, reject) => {
            this.affiliate = null;
            this.authService.isLoggedIn().then(() => {
                this.apiService.getAffiliate(this.filter_params['affiliate_id']).then((affiliate) => {
                    if(affiliate) {
                        this.affiliate = affiliate;
                    }
                    resolve();
                })
                .catch((error) => {
                    if(error.status == 400) {
                        this.presentAlert("Problem", 'Unknown error', 'Unfortunately something went wrong when trying to retrieve an affiliate.');
                    } 
                    else if(error.status == 403) {
                        this.presentAlert("Problem", 'Insufficient permissions', "You don't have permission to view an affiliate.");
                    } 
                    else if(error.status == 404 || error.status == 0) {
                        this.presentAlert("Problem", 'Unavailable', "Unfortunately we're unable to retrieve an affiliate at this time.");
                    }
                    reject();
                });
            })
            .catch(() => {
                this.router.navigate(['switch-account'], { replaceUrl: true }).then(() => {
                    window.location.reload();
                });
            });
        });
    }

    close() {
        this.modalController.dismiss();
    }

    filter() {

        if(this.filter_params["timeframe"]) {
            if(this.filter_params['timeframe'] == "today") {
                this.filter_params['from_date'] = this.moment().startOf("day").utc().format();
                this.filter_params['to_date'] = this.moment().endOf("day").utc().format();
            }
            else if(this.filter_params['timeframe'] == "yesterday") {
                this.filter_params['from_date'] = this.moment().startOf("day").subtract(1, 'days').utc().format();
                this.filter_params['to_date'] = this.moment().endOf("day").subtract(1, 'days').utc().format();
            }
            else if(this.filter_params['timeframe'] == "this_week") {
                this.filter_params['from_date'] = this.moment().startOf("isoWeek").utc().format();
                this.filter_params['to_date'] = this.moment().endOf("isoWeek").utc().format();
            }
            else if(this.filter_params['timeframe'] == "last_week") {
                this.filter_params['from_date'] = this.moment().startOf("isoWeek").subtract(1, 'weeks').utc().format();
                this.filter_params['to_date'] = this.moment().endOf("isoWeek").subtract(1, 'weeks').utc().format();
            }
            else if(this.filter_params['timeframe'] == "this_month") {
                this.filter_params['from_date'] = this.moment().startOf("month").utc().format();
                this.filter_params['to_date'] = this.moment().endOf("month").utc().format();
            }
            else if(this.filter_params['timeframe'] == "last_month") {
                this.filter_params['from_date'] = this.moment().startOf("month").subtract(1, 'months').utc().format();
                this.filter_params['to_date'] = this.moment().endOf("month").subtract(1, 'months').utc().format();
            }
        }
        else {
            if(this.filter_params['from_date']) {
                this.filter_params['from_date'] = this.moment(this.filter_params['from_date']).utc().format();
            }
            if(this.filter_params['to_date']) {
                this.filter_params['to_date'] = this.moment(this.filter_params['to_date']).utc().format();
            }
        }

        this.modalController.dismiss(this.filter_params);

    }

    clearTimeframe() {
        delete this.filter_params['timeframe'];
    }

    clearIsAwaitingFulfillment() {
        delete this.filter_params['is_awaiting_fulfillment'];
    }

    clearIsAwaitingPayment() {
        delete this.filter_params['is_awaiting_payment'];
    }

    clearStatus() {
        delete this.filter_params['status'];
    }

    clearPaymentStatus() {
        delete this.filter_params['payment_status'];
    }

    clearFulfillmentStatus() {
        delete this.filter_params['fulfillment_status'];
    }

    clearReturnStatus() {
        delete this.filter_params['return_status'];
    }

    clearRefundStatus() {
        delete this.filter_params['refund_status'];
    }

    clearAwaitingPaymentMethod() {
        delete this.filter_params['awaiting_payment_method'];
    }

    clearChannel() {
        delete this.filter_params['channel'];
    }

    clearRegister() {
        delete this.filter_params['register_id'];
    }

    clearPricingTier() {
        delete this.filter_params['pricing_tier_id'];
    }

    clearCurrency() {
        delete this.filter_params['currency_id'];
    }

    clearLocation() {
        delete this.filter_params['location_id'];
    }

    clearArchived() {
        delete this.filter_params['archived'];
    }

    clearFilters() {
        this.presentSpinner("Clearing filters").then(() => {

            if(this.filter_params['timeframe']) {
                delete this.filter_params["timeframe"];
            }
            if(this.filter_params['from_date']) {
                delete this.filter_params["from_date"];
                this.formatted_from_date = null;
            }
            if(this.filter_params['to_date']) {
                delete this.filter_params["to_date"];
                this.formatted_to_date = null;
            }
            if('is_awaiting_fulfillment' in this.filter_params) {
                delete this.filter_params["is_awaiting_fulfillment"];
            }
            if('is_awaiting_payment' in this.filter_params) {
                delete this.filter_params["is_awaiting_payment"];
            }
            if(this.filter_params['status']) {
                delete this.filter_params["status"];
            }
            if(this.filter_params['payment_status']) {
                delete this.filter_params["payment_status"];
            }
            if(this.filter_params['fulfillment_status']) {
                delete this.filter_params["fulfillment_status"];
            }
            if(this.filter_params['refund_status']) {
                delete this.filter_params["refund_status"];
            }
            if(this.filter_params['return_status']) {
                delete this.filter_params["return_status"];
            }
            if(this.filter_params['awaiting_payment_method']) {
                delete this.filter_params["awaiting_payment_method"];
            }
            if(this.filter_params['channel']) {
                delete this.filter_params["channel"];
            }
            if(this.filter_params['register_id']) {
                delete this.filter_params["register_id"];
            }
            if(this.filter_params['pricing_tier_id']) {
                delete this.filter_params["pricing_tier_id"];
            }
            if(this.filter_params['currency_id']) {
                delete this.filter_params["currency_id"];
            }
            if(this.filter_params['location_id']) {
                delete this.filter_params["location_id"];
            }

            // NOTE: order list has been called from organisation view, need to prevent organisation_id being cleared
            if(!this.hide_organisation_selector && this.filter_params['organisation_id']) {
                delete this.filter_params["organisation_id"];
                this.organisation_title = null;
            }

            if(this.filter_params['affiliate_id']) {
                delete this.filter_params["affiliate_id"];
                this.affiliate_name = null;
            }
            if('archived' in this.filter_params) {
                delete this.filter_params["archived"];
            }

            this.spinner.dismiss();

        });
    }

    async presentFromDateTimePickerModal() {
        if(!this.date_picker_modal_open) {
            this.date_picker_modal_open = true;
            const modal = await this.modalController.create({
                component: DateTimePickerPage,
                cssClass: this.date_modal_css_class,
                componentProps: {
                    date: (this.filter_params['from_date'] ? this.filter_params['from_date'] : ""),
                    format: "date-time",
                    clear_date: true
                }
            })
            modal.onDidDismiss().then((data) => {
                this.date_picker_modal_open = false;
                if(data.data) {
                    if(data.data == "date_deleted") {
                        delete this.filter_params["from_date"];
                        this.formatted_from_date = null;
                    }
                    else {
                        this.filter_params['from_date'] = data.data['date'];
                        this.formatted_from_date = this.moment(this.filter_params['from_date']).format("D MMM YYYY, HH:mm");
                    }
                }
            });
            return await modal.present();
        }
        else {
            return null;
        }
    }

    async presentToDateTimePickerModal() {
        if(!this.date_picker_modal_open) {
            this.date_picker_modal_open = true;
            const modal = await this.modalController.create({
                component: DateTimePickerPage,
                cssClass: this.date_modal_css_class,
                componentProps: {
                    date: (this.filter_params['to_date'] ? this.filter_params['to_date'] : ""),
                    format: "date-time",
                    clear_date: true
                }
            })
            modal.onDidDismiss().then((data) => {
                this.date_picker_modal_open = false;
                if(data.data) {
                    if(data.data == "date_deleted") {
                        delete this.filter_params["to_date"];
                        this.formatted_to_date = null;
                    }
                    else {
                        this.filter_params['to_date'] = data.data['date'];
                        this.formatted_to_date = this.moment(this.filter_params['to_date']).format("D MMM YYYY, HH:mm");
                    }
                }
            });
            return await modal.present();
        }
        else {
            return null;
        }
    }

    async presentOrganisationPickerModal() {
        if(!this.organisation_picker_modal_open) {
            this.organisation_picker_modal_open = true;
            const modal = await this.modalController.create({
                component: OrganisationPickerPage,
                componentProps: {
                    organisation_id: (this.filter_params['organisation_id'] ? this.filter_params['organisation_id'] : null),
                    hide_add_organisation_button: true
                }
            });
            modal.onDidDismiss().then((data) => {
                this.organisation_picker_modal_open = false;
                if(data.data) {
                    if(data.data['picker_action'] == "organisation_deleted") {
                        delete this.filter_params["organisation_id"];
                        this.organisation_title = null;
                    }
                    else {
                        this.filter_params['organisation_id'] = data.data['organisation_id'];
                        this.organisation_title = data.data['organisation_title'];
                    }

                }
            });
            return await modal.present();
        }
        else {
            return null;
        }
    }

    async presentAffiliatePickerModal() {
        if(!this.affiliate_picker_modal_open) {
            this.affiliate_picker_modal_open = true;
            const modal = await this.modalController.create({
                component: AffiliatePickerPage,
                componentProps: {
                    affiliate_id: (this.filter_params['affiliate_id'] ? this.filter_params['affiliate_id'] : null)
                }
            });
            modal.onDidDismiss().then((data) => {
                this.affiliate_picker_modal_open = false;
                if(data.data) {
                    if(data.data['picker_action'] == "affiliate_deleted") {
                        delete this.filter_params["affiliate_id"];
                        this.affiliate_name = null;
                    }
                    else {
                        this.filter_params['affiliate_id'] = data.data['affiliate_id'];
                        this.affiliate_name = data.data['affiliate_name'];
                    }

                }
            });
            return await modal.present();
        }
        else {
            return null;
        }
    }

    async presentAlert(header, sub_header, message) {
        const alert = await this.alertController.create({
            header: header,
            subHeader: sub_header,
            message: message,
            cssClass:'alert',
            buttons: ['OK']
        });
        await alert.present();
    }

    async presentLoadingSpinner(message) {
        this.loading = true;
        this.loading_spinner = await this.loadingController.create({
            message: message,
            showBackdrop: false,
            cssClass: 'loading-spinner'
        });
        this.loading_spinner.onDidDismiss().then(() => {
            this.loading = false;
        });
        await this.loading_spinner.present();
    }

    async presentSpinner(message) {
        this.spinner = await this.loadingController.create({
            message: message,
            showBackdrop: false,
            cssClass: 'loading-spinner'
        });
        await this.spinner.present();
    }

}
